import {
  FREE_PLAN_BAR_CLICK_ON_SCHEDULE_DEMO,
  FREE_PLAN_BAR_CLICK_ON_UPGRADE
} from '@constants/mixpanel'
import { defaultLitePlan } from '@constants/plans'
import { useAcl } from '@contexts/acl'
import NiceModal from '@ebay/nice-modal-react'
import Diamond from '@images/diamond.png'
import { UPGRADE } from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/planCTAs'
import { MODAL_SUMMARY_SUBSCRIPTION } from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal'
import SummarySubscriptionModal from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal/SummarySubscriptionModal'
import { AccountPackageProvider } from '@pages/Pricing/routes/AccountPackage/contexts'
import { useGetAnyLead } from '@services/leads/useGetAnyLead'
import { useGetAccountLimits } from '@services/limits'
import { mixpanelEvent } from '@services/mixpanel'
import { Button, Icon, Image, Paragraph, Spreader } from '@ui-kit'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import { LimitBadge } from './components/LimitBadge'
import { MODAL_UPGRADE_TO_LITE } from './components/UpgradeToLiteModal'
import styles from './FreePlans.module.scss'

export const FreePlans = () => {
  const { t } = useTranslation()

  const hasAccessToChangePlan = useAcl('plan.change_plan')

  const { data: leads, isLoading: isLoadingLeads } = useGetAnyLead({})

  const limits = useGetAccountLimits()

  const { uniqueVisits, landingPages, isLoading: isLoadingLimits } = limits

  const isLoading = isLoadingLeads || isLoadingLimits

  const handleRedirectToLP = () => {
    mixpanelEvent({
      name: FREE_PLAN_BAR_CLICK_ON_SCHEDULE_DEMO
    })

    window.open(t('infobar.free.plans.button.schedule.demo.link'), '_blank')
  }

  const handleOpenModal = () => {
    mixpanelEvent({
      name: FREE_PLAN_BAR_CLICK_ON_UPGRADE
    })

    NiceModal.show(MODAL_UPGRADE_TO_LITE)
  }

  return (
    <div className={styles['free-plan']}>
      <Row
        className={styles['free-plan__description']}
        vertical='center'
        alignItems='center'
      >
        <Image src={Diamond} width='22px' height='22px' />

        <Spreader spread={15} />

        <Paragraph>
          <Trans i18nKey='infobar.free.plans' />
        </Paragraph>
      </Row>

      <Spreader spread={30} />

      <Column
        className={styles['free-plan__limits']}
        vertical='center'
        horizontal='end'
        wrap
      >
        {isLoading ? null : (
          <Fragment>
            <Row>
              <Row vertical='center' alignItems='center'>
                <Paragraph size={12} weight={600} color='neutral-8'>
                  <Trans i18nKey='topbar.unique-visitors' />
                </Paragraph>

                <Spreader spread={5} />

                {uniqueVisits ? (
                  <LimitBadge
                    quantity={uniqueVisits?.uniqueVisitsCount}
                    limit={uniqueVisits?.uniqueVisitsLimit}
                  />
                ) : null}
              </Row>

              <Spreader spread={15} />

              <Row vertical='center' alignItems='center'>
                <Paragraph size={12} weight={600} color='neutral-8'>
                  <Trans i18nKey='sidebar.conversions' />
                </Paragraph>

                <Spreader spread={5} />

                {leads ? (
                  <LimitBadge
                    quantity={leads.pagination.counter.total}
                    limit={100}
                  />
                ) : null}
              </Row>
            </Row>

            <Spreader spread={15} />

            <Row vertical='center' alignItems='center'>
              <Paragraph size={12} weight={600} color='neutral-8'>
                <Trans i18nKey='topbar.published-landing-pages' />
              </Paragraph>

              <Spreader spread={5} />

              {landingPages ? (
                <LimitBadge
                  quantity={landingPages?.landingPagePublicationCount}
                  limit={landingPages?.landingPagePublicationLimit}
                />
              ) : null}
            </Row>
          </Fragment>
        )}
      </Column>

      <Spreader spread={30} />

      <Row className={styles['free-plan__buttons']}>
        <Button variant='outlined' onClick={handleRedirectToLP}>
          <Trans i18nKey='infobar.free.plans.button.schedule.demo' />
        </Button>

        {hasAccessToChangePlan && (
          <Fragment>
            <Spreader spread={10} />

            <Button onClick={handleOpenModal}>
              <Icon icon='icon-diamond' size={14} />

              <Spreader spread={5} />

              <Trans i18nKey='word.upgrade' />
            </Button>
          </Fragment>
        )}
      </Row>

      <AccountPackageProvider>
        <SummarySubscriptionModal
          id={MODAL_SUMMARY_SUBSCRIPTION}
          planRecordKey={defaultLitePlan}
          buttonType={UPGRADE}
        />
      </AccountPackageProvider>
    </div>
  )
}

FreePlans.displayName = 'TopbarInfobarFreePlans'
